<template>
  <div class="competency-tech-expert">
    <img src="@/assets/images/avatar.svg" alt="" class="ccs-avatar">
    <div class="ccs-fields">
      <div class="ccs-field">
        <div class="field-name">
          Фамилия
        </div>
        <div class="field-value">
          Семенов
        </div>
      </div>
      <div class="ccs-field">
        <div class="field-name">
          Имя и Отчество
        </div>
        <div class="field-value">
          Николай Анатольевич
        </div>
      </div>
      <div class="ccs-field">
        <div class="field-name">
          Email
        </div>
        <div class="field-value">
          semenov-nikolay@long-template.com
        </div>
      </div>
      <div class="ccs-field">
        <div class="field-name">
          Телефон
        </div>
        <div class="field-value">
          +7-926-123-45-67
        </div>
      </div>
      <div class="ccs-field">
        <div class="field-name">
          Размер одежды
        </div>
        <div class="field-value">
          M
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechExpert',
};
</script>

<style lang="scss" scoped>
.competency-tech-expert {
  min-height: 100%;
  min-width: 100%;
  background: #fff;
}
</style>
